var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiryDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2D6CE6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.094 2c.518 0 .937.42.937.938v.937h1.219c2.068 0 3.75 1.682 3.75 3.75v2.344c0 .518-.42.937-.938.937-.517 0-.937-.42-.937-.937V7.625c0-1.034-.841-1.875-1.875-1.875h-1.219v.938c0 .517-.42.937-.937.937-.518 0-.938-.42-.938-.938V5.75h-6.36v.938c0 .517-.419.937-.937.937-.517 0-.937-.42-.937-.938V5.75H5.75c-1.034 0-1.875.841-1.875 1.875V18.25c0 1.034.841 1.875 1.875 1.875h4.172c.518 0 .937.42.937.938 0 .517-.42.937-.937.937H5.75C3.682 22 2 20.318 2 18.25V7.625c0-2.068 1.682-3.75 3.75-3.75h1.172v-.938c0-.517.42-.937.937-.937.518 0 .938.42.938.938v.937h6.36v-.938c0-.517.419-.937.937-.937zm.234 8.656c3.128 0 5.672 2.545 5.672 5.672C22 19.456 19.456 22 16.328 22c-3.127 0-5.672-2.544-5.672-5.672 0-3.127 2.545-5.672 5.672-5.672zm0 1.875c-2.093 0-3.797 1.704-3.797 3.797 0 2.094 1.704 3.797 3.797 3.797 2.094 0 3.797-1.703 3.797-3.797 0-2.093-1.703-3.797-3.797-3.797zm0 .938c.518 0 .938.42.938.937v.985h.422c.517 0 .937.42.937.937 0 .518-.42.938-.938.938h-1.359c-.518 0-.937-.42-.937-.938v-1.922c0-.518.42-.937.937-.937z",
    transform: "translate(-160.000000, -216.000000) translate(144.000000, 208.000000) translate(16.000000, 8.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiryDate);
export default __webpack_public_path__ + "static/media/expiry-date.9efa1df69aac0c3f13d9f0aaf29e19a3.svg";
export { ForwardRef as ReactComponent };